/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import get from 'lodash/get';
import { withNamespaces } from 'react-i18next';

import { Column, MediaQueries } from '../../../../styles/Grid';
import { showElementCss } from '../../../../utils/responsive';
import { SafePureComponent } from '../../../../utils/SafePureComponent';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import {
  itemsContainerCss,
  titleCss,
  descriptionCss,
  bottom_links,
  verticalLineCss,
} from './index.styles';
import { navbar_finite_state } from '../../../../contexts/NavContext';
import { NAVBAR_IDS } from '../../../../utils/constants';

export const onClickNavigationItem = (event, waysToWorkItems) => {
  const { id } = event.target;
  const [itemFiltered] = waysToWorkItems.filter(
    item => id === get(item, 'fields.id', 0),
  );
  const url = get(itemFiltered, 'fields.FindOutMoreCta.value.href', '');
  window.open(url, '_self');
};

class NewWaysToWork extends SafePureComponent {
  state = {
    openedAccordian: ['menu-0'],
    showLocationsPopup: false,
    hoveredElement: get(
      this.props.fields,
      'NavigationItems.value[0].fields.id',
      0,
    ),
  };

  onInteractionItem = event => {
    const { id } = event.target;
    this.setState({ hoveredElement: id });
  };

  showLocationPopupHandler = () => {
    this.setState({
      showLocationsPopup: true,
    });
  };
  hideLocationPopupHandler = () => {
    this.setState({
      showLocationsPopup: false,
    });
  };

  getCTALabel = data => {
    const {
      LinkText,
      // Type,
      // Label,
      IconPosition,
      // ContactNumber,
      // Icon,
    } = data;

    return (
      <React.Fragment>
        {(IconPosition == 'Left' || IconPosition == null) && data.Icon && (
          <span>
            <img src={data.Icon} alt={LinkText} />
          </span>
        )}
        <span>{LinkText}</span>
        {IconPosition == 'Right' && data.Icon && (
          <span>
            <img src={data.Icon} alt={LinkText} />
          </span>
        )}
      </React.Fragment>
    );
  };

  getSubTabs = data => {
    return data.map((item, index) => {
      return (
        <div className="subtabs" key={`subtab-${index}`}>
          <h3>{item.Label}</h3>
          {item.Links.map((subItem, subItemIndex) => {
            return (
              <div key={`subtab-${index}-${subItemIndex}`}>
                {this.getMenuItem(subItem)}
              </div>
            );
          })}
        </div>
      );
    });
  };

  getMenuItem = (data, isActive = false) => {
    const {
      Link,
      // LinkText,
      Type,
      Label,
      // IconPosition,
      ContactNumber,
      // Icon,
      // SubTabs,
    } = data;
    const activeClass = isActive ? 'is-active' : '';

    if (Type === 'Standard') {
      return (
        <a href={Link} className={activeClass} data-copy={data.LinkText}>
          {this.getCTALabel(data)}
        </a>
      );
    } else if (Type === 'Contact') {
      return (
        <a
          href={`tel:${ContactNumber}`}
          className="sales-number"
          data-copy={Label}
        >
          <span>{Label}</span>
          <span>{ContactNumber}</span>
        </a>
      );
    } else if (Type === 'Modal') {
      let modalId;
      let buttonID;
      let ariaLabel;
      if (Link == 'SEARCH_LOCATION') {
        modalId = navbar_finite_state.SEARCH_NAV;
        buttonID = NAVBAR_IDS.SEARCH_ACTIVE;
        ariaLabel = 'Search';
      }

      return (
        <button
          id={buttonID}
          onClick={() =>
            this.props.openModal({
              target: { dataset: { id: modalId } },
            })
          }
          data-id={modalId}
          aria-label={ariaLabel}
          data-copy={data.LinkText}
        >
          {this.getCTALabel(data)}
        </button>
      );
    } else {
      return (
        <a href={Link} className="sales-number" data-copy={Label}>
          <span>{Label}</span>
          <span>{ContactNumber}</span>
        </a>
      );
    }
  };

  preOpenAccordian = () => {
    const { fields, showHelpAndSupport } = this.props;
    if (showHelpAndSupport) {
      const leftMenu = get(fields, 'NavObject.value.LeftMenu', {});
      const selectedIndex = leftMenu.VerticalTabs.findIndex(item => {
        return item.IsExpanded;
      });
      if (selectedIndex > -1) {
        return 'menu-' + selectedIndex;
      }
    }
    return 'menu-0';
  };

  changeAccrodianTab = uuid => {
    this.setState({ openedAccordian: uuid });
  };

  safeRender() {
    const { fields } = this.props;
    const { showLocationsPopup, openedAccordian } = this.state;

    const leftMenu = get(fields, 'NavObject.value.LeftMenu', {});
    // const rightMenu = get(fields, 'NavObject.value.RightMenu', {});

    return (
      <React.Fragment>
        {showLocationsPopup == false && (
          <React.Fragment>
            <Column css={itemsContainerCss}>
              <Accordion
                preExpanded={[this.preOpenAccordian()]}
                onChange={this.changeAccrodianTab}
              >
                {leftMenu?.VerticalTabs &&
                  leftMenu.VerticalTabs.map((item, index) => {
                    return (
                      <AccordionItem
                        key={index}
                        uuid={`menu-${index}`}
                        data-expand={openedAccordian.includes(`menu-${index}`)}
                        data-copy={item.Label}
                      >
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            <h2>
                              <span>{item.Label}</span>
                            </h2>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <ul>
                            {item.Links.map((subitem, index) => {
                              return (
                                <li key={index}>{this.getMenuItem(subitem)}</li>
                              );
                            })}
                          </ul>
                          {item.SubTabs && this.getSubTabs(item.SubTabs)}
                        </AccordionItemPanel>
                      </AccordionItem>
                    );
                  })}
              </Accordion>
            </Column>
            <div css={[bottom_links]}>
              <ul>
                {leftMenu?.HorizontalTabs &&
                  leftMenu.HorizontalTabs.map((item, index) => {
                    return (
                      <li key={index}>
                        <a href={item.Link}>
                          <span>{item.LinkText}</span>
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </React.Fragment>
        )}

        <span css={[verticalLineCss, showElementCss(MediaQueries.xl)]} />
      </React.Fragment>
    );
  }
}

NewWaysToWork.displayName = 'NavigationV2/NewWaysToWork';

NewWaysToWork.defaultProps = {
  t: key => key,
};

export default withNamespaces()(NewWaysToWork);
